import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { CompteursAbsenceDto } from "../../../dto/GenApi.iNotPaie.Dto/CompteursAbsenceDto";

@Component({
    components: {
        SituationManager: require("./tableaux/situationManager/situationManager.vue.html"),
        SituationSalarie: require("./tableaux/situationSalarie/situationSalarie.vue.html")
    }
})
export default class SituationDesAbsences extends Vue {
    public dataReady = false;
    public anneeCouranteConges = new Date().getFullYear();
    public compteurAbsences?: CompteursAbsenceDto = undefined;
    public listeCompteursAbsencesEquipe?: CompteursAbsenceDto[] = undefined;


    @Prop()
    public isModeManager = false;

    public fetchData(): void {
        this.dataReady = false;
        this.anneeCouranteConges = new Date().getFullYear();
        this.compteurAbsences = undefined;
        this.listeCompteursAbsencesEquipe = undefined;

        ServicesFactoryInstance.CompteurAbsenceService.GetStatuAbsence(data => {
            if (data != undefined) {
                this.anneeCouranteConges = data.AnneeCouranteConges;
                this.compteurAbsences = data.CompteurbsencesSalarieConnecte;
                this.listeCompteursAbsencesEquipe = data.ListeCompteursAbsencesEquipe;
            }
            this.dataReady = true;
        }, () => this.dataReady = true);
    }
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/situationDesAbsences/situationDesAbsences.ts